import React, { FC, useMemo } from 'react';
import { Watermark } from '~/shared/components/Watermarks';
import styles from '../../PLPHero.module.scss';

export interface PLPHeroWatermarkProps {
    watermark?: string;
}

/**
 * PLPHeroWatermark component handles watermark display logic.
 * Currently defaults to Logo watermark when no specific type is provided.
 */
export const PLPHeroWatermark: FC<PLPHeroWatermarkProps> = ({ watermark }) => {
    const watermarkElement = useMemo(() => {
        // TODO: The commented code below forces a no watermark,
        // it will be a pain to change all watermarks for each categories soon after so let's keep a default

        // if (!watermark) return null;

        // Make the "Logo" the default
        return (
            <Watermark type={watermark === 'Percentage' ? 'Percentage' : 'Logo'} styles={styles} />
        );
    }, [watermark]);

    return watermarkElement;
};

export default PLPHeroWatermark;
